// src/App.js
import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Container,
  TextField,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
} from "@mui/material";
import PdfTableExtractor from "../../components/pdfExtractor";
import { getToken, base_url } from "../../config/config";

const ProjectHours = () => {
  const [ANR, setANR] = useState("");
  const [totalProjectCost, setTotalProjectCost] = useState(0);
  const [totalCostByUser, setTotalCostByUser] = useState(60); // Set the hourly rate
  const [workData, setWorkData] = useState([]);
  const [userTimes, setUserTimes] = useState({});

  const fetchData = () => {
    axios
      .get(`${base_url}/v1/getUserProjectReport/` + ANR)
      .then((response) => {
        if (response.data.status === 1) {
          setWorkData(response.data.data);
        } else {
          console.error("Error fetching API data:", response.data.message);
        }
      })
      .catch((error) => {
        console.error("Error fetching API data:", error);
      });
  };

  useEffect(() => {
    if (workData.length > 0) {
      const calculateUserTimes = () => {
        const times = {};

        workData.forEach((entry) => {
          const { user, TotalTime, StartTime, EndTime } = entry;
          let totalHours = 0;

          if (TotalTime !== "00:00:00") {
            const [hours, minutes, seconds] = TotalTime.split(":").map(Number);
            totalHours = hours + minutes / 60 + seconds / 3600;
          } else {
            const start = new Date(`1970-01-01T${StartTime}Z`);
            const end = new Date(`1970-01-01T${EndTime}Z`);
            totalHours = (end - start) / 3600000; // Convert milliseconds to hours
          }

          if (times[user]) {
            times[user] += totalHours;
          } else {
            times[user] = totalHours;
          }
        });

        setUserTimes(times);
      };

      calculateUserTimes();
    }
  }, [workData]);

  const totalTime = Object.values(userTimes).reduce(
    (acc, time) => acc + time,
    0,
  );
  const costByUser = totalTime * totalCostByUser;

  const profitOrLoss = totalProjectCost - costByUser;
  const profitOrLossColor = profitOrLoss >= 0 ? "green" : "red";

  return (
    <Container>
      {/* <Typography variant="h4" component="h1" gutterBottom>Cost by Hour Calculation</Typography> */}
      <div style={{ display: "flex", gap: "1rem", marginBottom: "1rem" }}>
        <TextField
          label='ANR'
          value={ANR}
          onChange={(e) => setANR(e.target.value)}
          variant='outlined'
        />
        <TextField
          label='Total Project Cost (€)'
          type='number'
          value={totalProjectCost}
          onChange={(e) => setTotalProjectCost(e.target.value)}
          variant='outlined'
        />
        <TextField
          label='Total Cost by User (€/hour)'
          type='number'
          value={totalCostByUser}
          onChange={(e) => setTotalCostByUser(e.target.value)}
          variant='outlined'
        />
        <Button variant='contained' color='primary' onClick={fetchData}>
          Fetch Data
        </Button>

        <Typography variant='h3' component='h2' gutterBottom>
          Total Cost by User: €{costByUser.toFixed(2)}
        </Typography>
        <Typography
          variant='h3'
          component='h2'
          gutterBottom
          style={{ color: profitOrLossColor }}>
          Profit/Loss: €{profitOrLoss.toFixed(2)}
        </Typography>
      </div>

      {/* <PdfTableExtractor/> */}
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>User</TableCell>
              <TableCell>Total Hours</TableCell>
              <TableCell>Cost (€)</TableCell>
              <TableCell>Description</TableCell>
              <TableCell>Start Time</TableCell>
              <TableCell>End Time</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {workData.map((entry) => {
              const { user, TotalTime, description, StartTime, EndTime } =
                entry;
              let totalHours = 0;

              if (TotalTime !== "00:00:00") {
                const [hours, minutes, seconds] =
                  TotalTime.split(":").map(Number);
                totalHours = hours + minutes / 60 + seconds / 3600;
              } else {
                const start = new Date(`1970-01-01T${StartTime}Z`);
                const end = new Date(`1970-01-01T${EndTime}Z`);
                totalHours = (end - start) / 3600000; // Convert milliseconds to hours
              }

              const userCost = (totalHours * totalCostByUser).toFixed(2);

              return (
                <TableRow key={entry._id}>
                  <TableCell>{user}</TableCell>
                  <TableCell>{totalHours.toFixed(2)}</TableCell>
                  <TableCell>{userCost}</TableCell>
                  <TableCell>{description}</TableCell>
                  <TableCell>{StartTime}</TableCell>
                  <TableCell>{EndTime}</TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Container>
  );
};

export default ProjectHours;
